































import Vue from 'vue';
import { NotificationMessageModel, NotificationMessageType, NotificationModel } from '@/types';

export default Vue.extend({
  name: 'MStoreNotification',
  props: {
    notification: {
      type: Object as () => NotificationModel,
      required: true
    }
  },
  computed: {
    notificationErrors(this: any) {
      return (this.notification as NotificationModel).messages?.filter(
        (x: NotificationMessageModel) => x.type === NotificationMessageType.Error
      );
    },
    notificationWarnings(this: any) {
      return (this.notification as NotificationModel).messages?.filter(
        (x: NotificationMessageModel) => x.type === NotificationMessageType.Warning
      );
    },
    hasErrors(this: any) {
      return Boolean(this.notificationErrors && this.notificationErrors.length);
    }
  }
});
